import React, { Fragment } from 'react'
import { Button } from '@drifthq/tide-core'
import { parse } from 'query-string'
import { Flow } from 'constants/flowConstants'

import GoogleAuth from './GoogleAuth'
import MicrosoftAuth from './MicrosoftAuth'

const SignupChoiceCard = ({ search, onProcessingGoogleCode, onProcessingExternalGoogleCode, onProcessingMicrosoftCode, flow, oauthError }) => {
  const { plan } = parse(search)
  const headerCopy = plan ? "Create your Drift account" : "Create your free Drift account"
  
  return (
    <Fragment>
      <h1 className="touchless-start-header">{headerCopy}</h1>
      <Button
        className="touchless-start-oauth-button"
        size="large"
        linkTo={flow === Flow.VIDEO ? '/start/signup/video' : '/start/signup'}
      >
        Sign up with email
      </Button>
      <div className="touchless-start-oauth-border">
        <p>or</p>
      </div>
      <GoogleAuth onProcessingGoogleCode={onProcessingGoogleCode} onProcessingExternalGoogleCode={onProcessingExternalGoogleCode}/>
      <MicrosoftAuth onProcessingMicrosoftCode={onProcessingMicrosoftCode}/>
      { oauthError &&
        <p className="touchless-start-button-error">{oauthError}</p>
      }
    </Fragment>
  )
}

export default SignupChoiceCard



// WEBPACK FOOTER //
// ./src/layouts/SignupChoiceCard/component.js